import baseTheme from '../baseTheme';
import colors from '../colors';
export var MuiButton = {
    // this is the style used for the primary button
    contained: {
        minHeight: '36px',
        padding: '6px 16px',
        borderRadius: '33.6px',
        fontWeight: 600,
        fontSize: baseTheme.typography.pxToRem(14),
        boxShadow: 'none',
        '&:focus': {
            boxShadow: 'none',
        },
        '&.Mui-disabled': {
            backgroundColor: baseTheme.palette.grey[200],
            color: baseTheme.palette.grey[800],
        },
    },
    containedPrimary: {
        '&:focus': {
            background: baseTheme.palette.primary.dark,
        },
    },
    // this is the style used for the secondary button
    outlined: {
        minHeight: '36px',
        borderWidth: '2px',
        // border width is subtracted
        padding: '4px 14px',
        borderRadius: '33.6px',
        fontWeight: 600,
        fontSize: baseTheme.typography.pxToRem(14),
        boxShadow: 'none',
    },
    outlinedSecondary: {
        borderWidth: '2px',
        borderColor: baseTheme.palette.secondary.main,
        '&:hover': {
            borderWidth: '2px',
            backgroundColor: baseTheme.palette.secondary.main,
            color: baseTheme.palette.primary.contrastText,
        },
        '&:focus': {
            borderWidth: '2px',
            backgroundColor: baseTheme.palette.secondary.main,
            color: baseTheme.palette.primary.contrastText,
        },
    },
    text: {
        fontWeight: 600,
        padding: 0,
        position: 'relative',
        lineHeight: '1.5',
        borderRadius: '2em',
        '&::after': {
            content: '""',
            borderRadius: '2em',
            height: '1px',
            width: '100%',
            position: 'absolute',
            bottom: '0',
            left: '0',
            backgroundColor: baseTheme.palette.text.primary,
            opacity: 0,
            transition: 'height 0.15s ease, width 0.15s ease, left 0.15s ease, opacity 0.25s ease',
        },
        '&:hover': {
            backgroundColor: 'transparent',
            '&::after': {
                height: 'calc(100% + 0.2em)',
                width: 'calc(100% + 0.6em)',
                left: '-0.3em',
                opacity: '0.125',
                transition: 'height 0.15s ease, width 0.15s ease, left 0.15s ease, opacity 0s ease',
            },
        },
        // a sort of fix for the looks of the focus-visible
        // 'breathing' ripple effect, which seems out of place
        // without at least a containing idea of a bubble present.
        '&.Mui-focusVisible': {
            '&::after': {
                opacity: 0.1,
                height: 'calc(100% + 0.2em)',
                width: 'calc(100% + 0.6em)',
                left: '-0.3em',
                transition: 'height 0.15s ease, width 0.15s ease, left 0.15s ease, opacity 0s ease',
            },
        },
        '&:active': {
            '&::after': {
                opacity: 0.05,
            },
        },
    },
    textPrimary: {
        color: colors.blue[700],
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&::after': {
            backgroundColor: colors.blue[700],
        },
        '&.Mui-disabled': {
            color: baseTheme.palette.text.disabled,
        },
    },
    textSecondary: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&::after': {
            backgroundColor: baseTheme.palette.secondary.main,
        },
    },
};
//# sourceMappingURL=MuiButton.js.map